import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe, Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';

@Component({
  selector: 'app-attestation',
  templateUrl: './attestation.component.html',
  styleUrls: ['./attestation.component.scss']
})
export class AttestationComponent implements OnInit {
  AttestationForm: FormGroup;
  @ViewChild('fileUploader') fileUploader: ElementRef;

  StuId: any;
  InstId: any;
  CollegeList: any;
  filteredCollegeList: any;
  courseList: any;
  filteredCourseList: any;
  StuFullName: string;
  RegnNo: string;
  formattedPrn: string;
  PreFix: any;

  Table = false;
  Approved = false;
  SaveBtn = false;
  UpdateBtn = false;
  PayFee = false;
  PayRecpt = false;
  DocTable = false;
  DocView = false;
  SaveDisabled = false;
  UpdateDisabled = false;
  PayDisabled = false;
  isdisabled = false;
  isreadonly = false;
  fileName: string;
  errormessage: string;
  errMsg: string;
  uploadDoc: any;
  uploadDoc2: any;
  fileUploads: any;
  TclcData: any;
  TclcId: any;
  TclcDocData: any;
  AttestationData: any;
  AdminUpload: any = [];
  FeeStatus: any;
  Status: string;
  dialogRef: MatDialogRef<any>;

  defaultAttestationDocs = [
    { SrNo: 1, DocName: 'Original Marksheets (First Year to Final Year with fail, if any)' },
    { SrNo: 2, DocName: 'Passing Certificate/Degree Certificate/Internship Completion Certificate' },
    { SrNo: 3, DocName: 'Registration Certificate and Identity Certificate (Aadhar/Passport etc.)' },
    { SrNo: 4, DocName: 'Photo of student' }
  ];

  deliveryList = [
    { value: 'Soft', dropdownValue: 'Soft', Value: 'Soft Copy' },
    { value: 'Hard', dropdownValue: 'Hard', Value: 'Hard Copy' },
    { value: 'Both', dropdownValue: 'Both', Value: 'Both' }
  ];
  deliveryOptionList = [
    { value: 'IN', deliveryOptionValue: 'IN', Value: 'Within India Delivery' },
    { value: 'OFI', deliveryOptionValue: 'OFI', Value: 'Out Of India Delivery' },
  ];

  minDate = new Date(2000, 0, 1);
  private isLoadingDocs = false;

  // Maximum allowed file size per document: 50KB
  readonly MAX_FILE_SIZE = 50 * 1024; // 51200 bytes

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private location: Location,
    private cdr: ChangeDetectorRef,
    public umsService: UmsService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.UpdateBtn = false;
    this.isdisabled = false;
    this.DocTable = false;
    this.DocView = false;
    this.SaveBtn = false;
    this.PayFee = false;
    this.Table = false;
    this.UpdateDisabled = false;
    this.PayDisabled = false;

    this.RegnNo = sessionStorage.getItem('StudentRGID');
    this.formattedPrn = this.RegnNo?.toString().padStart(8, '0');

    // ---------- FORM GROUP WITH ADDED StuRgNo ----------
    this.AttestationForm = this.fb.group({
      StuCourse: new FormControl('', Validators.required),
      StuClg: new FormControl('', Validators.required),
      StuName: new FormControl({ value: '', disabled: true }),
      StuRgNo: new FormControl({ value: '', disabled: true }), 
      StuFromDate: new FormControl('', [Validators.required, this.validYearValidator]),
      StuToDate: new FormControl('', [Validators.required, this.validYearValidator]),
      CouncilRegNo: new FormControl('', Validators.required),
      StuAdd: new FormControl(''),
      StuPin: new FormControl(''),
      StuPhone: new FormControl(''),
      StuEmail: new FormControl('', Validators.required),
      StuCertCopies: new FormControl('', Validators.required),
      AttestationId: new FormControl(''),
      arrData: this.fb.array([]),
      DeliveryOpt: new FormControl('', Validators.required),
      EmailId: new FormControl(''),
      PostalAdd: new FormControl(''),
      DeliverAt: new FormControl(''),
      isSameAddr: new FormControl(false)
    });

    this.getStuId();
    this.getSecretData();

    this.AttestationForm.get('StuFromDate')?.valueChanges.subscribe(() => {
      this.checkDatePair('StuFromDate', 'StuToDate');
    });
    this.AttestationForm.get('StuToDate')?.valueChanges.subscribe(() => {
      this.checkDatePair('StuFromDate', 'StuToDate');
    });
  }

  // ---------- Validators ----------
  validYearValidator = (control: AbstractControl) => {
    const inputDate = control.value;
    if (inputDate && !isNaN(Date.parse(inputDate))) {
      const year = new Date(inputDate).getFullYear();
      if (year < 1000 || year > 9999) return { invalidYear: true };
    }
    return null;
  };

  checkDatePair(fromKey: string, toKey: string) {
    const from = this.AttestationForm.get(fromKey)?.value;
    const to = this.AttestationForm.get(toKey)?.value;
    if (from && to && new Date(from) > new Date(to)) {
      this.AttestationForm.get(toKey)?.setErrors({ dateMismatch: true });
    } else {
      const toControl = this.AttestationForm.get(toKey);
      if (toControl?.hasError('dateMismatch')) toControl.setErrors(null);
    }
  }

  copyAddress(event: any) {
    if (event.checked) {
      this.isreadonly = true;
      this.AttestationForm.controls['PostalAdd'].setValue(this.AttestationForm.controls['StuAdd'].value);
    } else {
      this.isreadonly = false;
      this.AttestationForm.controls['PostalAdd'].setValue('');
    }
  }

  // ---------- API Calls ----------
  getSecretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe({
      next: (res) => { if (res.status) this.InstId = res.projectPharam['ClubPartTrans']; this.spinner.hide(); },
      error: () => this.spinner.hide()
    });
  }

  getStuId() {
    this.spinner.show();
    const payload = { StuRgNo: sessionStorage.getItem('StudentRGID') };
    this.umsService.fetchPersonalDetails(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          const data = res.data[0];
          this.StuFullName = data.StuFullNameEng;
          this.RegnNo = data.StuRgNo;
          // Set PRN in the form control
          this.AttestationForm.controls['StuRgNo'].setValue(this.RegnNo);
          this.AttestationForm.controls['StuName'].setValue(this.StuFullName);
          this.AttestationForm.controls['StuEmail'].setValue(data.EmailID);
          this.AttestationForm.controls['StuPhone'].setValue(data.StuNumber);
          this.StuId = data.StuId;

          this.getCourseDataByStudent(this.StuId);
          this.getCollegeByStudent(this.StuId);
          this.ContactDetails(this.StuId);
          this.GetAttestation(this.StuId);
        } else {
          this.SaveDisabled = true;
        }
        this.spinner.hide();
      },
      error: () => { this.spinner.hide(); this.SaveDisabled = true; }
    });
  }

  getCourseDataByStudent(StuId: number) {
    const payload = { StuId };
    this.umsService.StudentSubjectSelectionById(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          const latest = res.data[res.data.length - 1];
          this.getCourseData(latest['SubCoId']);
        }
      },
      error: () => this.spinner.hide()
    });
  }

  getCourseData(CoCode: string) {
    this.spinner.show();
    this.umsService.fetchCourseType({ CoCode }).subscribe({
      next: (res) => {
        if (res.status) {
          this.courseList = res.data;
          this.filteredCourseList = [...this.courseList];
          this.PreFix = res.data[0]?.CoRgPrfx;
          this.AttestationForm.controls['StuCourse'].setValue(res.data[0]?.CoCode);
        }
        this.spinner.hide();
      },
      error: () => this.spinner.hide()
    });
  }

  getCollegeByStudent(StuId: number) {
    const payload = { StuId };
    this.umsService.StudentSubjectSelectionById(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          const latest = res.data[res.data.length - 1];
          this.getCollege(latest['SubCgId']);
        }
      }
    });
  }

  getCollege(CgCode: string) {
    this.spinner.show();
    this.umsService.getCollege({}).subscribe({
      next: (res) => {
        if (res.status) {
          this.CollegeList = res.data.filter(record => record.CgCode === CgCode);
          this.filteredCollegeList = [...this.CollegeList];
          this.AttestationForm.controls['StuClg'].setValue(this.CollegeList[0]?.CgCode);
        }
        this.spinner.hide();
      },
      error: () => this.spinner.hide()
    });
  }

  ContactDetails(StuId: number) {
    this.umsService.GetStuAddress({ StuId }).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          this.AttestationForm.controls['StuPin'].setValue(res.data[0].StuPinC);
          this.AttestationForm.controls['StuAdd'].setValue(res.data[0].FullAddress);
        }
      }
    });
  }

  GetAttestation(StuId: number) {
    this.spinner.show();
    this.umsService.SearchTranscript({ StuId }).subscribe({
      next: (res) => {
        console.log('Documents from API:', res);
        if (res.status && res.data.length) {
          this.UpdateBtn = true;
          this.SaveBtn = false;
          this.isdisabled = true;
          const d = res.data[0];
          this.AttestationForm.patchValue({
            StuCertCopies: d.StuCertCopies,
            CouncilRegNo: d.CouncilRegNo,
            StuFromDate: d.StuFromDate,
            StuToDate: d.StuToDate,
            AttestationId: d.TranscriptId,
            DeliveryOpt: d.DeliveryOpt,
            EmailId: d.EmailId,
            PostalAdd: d.PostalAdd,
            DeliverAt: d.DeliverAt,
            StuPin: d.StuPin,
            StuAdd: d.StuAdd,
            StuPhone: d.StuPhone,
            StuEmail: d.StuEmail
          });
          this.getTclcData(StuId);
          this.GetAttestationData(StuId);
        } else {
          this.UpdateBtn = false;
          this.SaveBtn = true;
          this.isdisabled = false;
          this.GetAttestationData(StuId);
        }
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.UpdateBtn = false;
        this.SaveBtn = true;
        this.GetAttestationData(StuId);
      }
    });
  }

 getTclcData(StuId: number) {
  this.spinner.show();
  const payload = { SessionId: parseInt(sessionStorage.getItem('session')), CertType: 'ATTFE' };
  this.umsService.GetTclcData(payload).subscribe({
    next: (res) => {
      if (res.status) {
        this.TclcData = res.data.filter(d => d.StuId == StuId);
        if (this.TclcData.length) {
          const tc = this.TclcData[0];
          this.FeeStatus = tc.FeeStatus;
          this.TclcId = tc.TclcId;
          this.UploadedDocs();

          if (tc.FeeStatus == 'Y') {
            this.PayFee = false;
            this.PayDisabled = true;
            this.PayRecpt = true;
          } else {
            this.PayDisabled = false;
            this.PayRecpt = false;
            this.ValidateFee(tc.StuId, tc.CertType, tc);
          }

          // ? REJ ? show Update button & allow editing
          if (tc.CertStatus == 'REJ') {
            this.SaveBtn = false;
            this.UpdateBtn = true;
            this.UpdateDisabled = false;
            this.isdisabled = false;
          }
          else if (tc.CertType == 'ATTFE') {
            this.SaveBtn = false;
            this.UpdateBtn = true;
            this.isdisabled = true;
          }
          else {
            this.SaveBtn = true;
            this.SaveDisabled = true;
            this.UpdateBtn = false;
            this.isdisabled = true;
          }

          switch (tc.CertStatus) {
            case 'APR': this.Status = 'Approved'; this.UpdateDisabled = true; break;
            case 'APPAP': this.Status = 'Application Approved'; this.UpdateDisabled = true; break;
            case 'REJ': this.Status = 'Rejected'; this.UpdateDisabled = false; break; // ? enabled
            case 'REC': this.Status = 'Rectify'; this.UpdateDisabled = false; break;
            case 'Fees Paid': this.Status = 'Fees Paid'; this.UpdateDisabled = true; break;
            case 'ReSubmitted': this.Status = 'Re-Submitted'; this.UpdateDisabled = false; break;
            case 'Submitted': this.Status = 'Submitted'; this.UpdateDisabled = true; this.PayFee = true; break;
            case 'UFD': this.Status = 'Certificate Generated'; this.UpdateDisabled = true; this.UploadedDocs(); break;
            default: this.Status = tc.CertStatus; this.UpdateDisabled = false;
          }
          this.Table = true;
          if (tc.CertStatus == 'APR') this.Approved = true;
        } else {
          this.Table = false;
        }
      }
      this.spinner.hide();
    },
    error: () => this.spinner.hide()
  });
}

  GetAttestationData(StuId: number) {
    if (this.isLoadingDocs) return;
    this.isLoadingDocs = true;
    this.spinner.show();
    const creds = this.AttestationForm.controls.arrData as FormArray;
    creds.clear();
    const payload = { SessionId: parseInt(sessionStorage.getItem('session')), CertType: 'ATTFE', StuId };
    this.umsService.GetTcLcDocDetails(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          this.DocView = true;
          this.SaveBtn = false;
          this.UpdateBtn = true;
          this.isdisabled = true;
          res.data.forEach((obj, i) => {
            creds.push(new FormGroup({
              DocumentName: new FormControl(obj.DocName),
              SrNo: new FormControl(obj.SrNo),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(obj.FileUpload),
              TclcDocId: new FormControl(obj.TclcDocId)
            }));
            if (!this.fileUploads) this.fileUploads = [];
            this.fileUploads[i] = obj.FileUpload;
          });
          this.DocTable = true;
        } else {
          this.CommonDocument(StuId);
        }
        this.spinner.hide();
        this.isLoadingDocs = false;
      },
      error: () => {
        this.spinner.hide();
        this.CommonDocument(StuId);
        this.isLoadingDocs = false;
      }
    });
  }

  CommonDocument(StuId: number) {
    this.DocTable = false;
    this.DocView = false;
    const payload = { ModuleType: 'ATTFE' };
    this.umsService.CommonDocument(payload).subscribe({
      next: (res) => {
        const creds = this.AttestationForm.controls.arrData as FormArray;
        creds.clear();
        if (res.status && res.data && res.data.length) {
          res.data.forEach(obj => {
            creds.push(new FormGroup({
              DocumentName: new FormControl(obj.DocName),
              SrNo: new FormControl(obj.SrNo),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(''),
              TclcDocId: new FormControl('')
            }));
          });
        } else {
          this.defaultAttestationDocs.forEach(doc => {
            creds.push(new FormGroup({
              DocumentName: new FormControl(doc.DocName),
              SrNo: new FormControl(doc.SrNo),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(''),
              TclcDocId: new FormControl('')
            }));
          });
        }
        this.DocTable = true;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.isdisabled = false;
        this.SaveDisabled = false;
        this.spinner.hide();
      },
      error: () => {
        const creds = this.AttestationForm.controls.arrData as FormArray;
        creds.clear();
        this.defaultAttestationDocs.forEach(doc => {
          creds.push(new FormGroup({
            DocumentName: new FormControl(doc.DocName),
            SrNo: new FormControl(doc.SrNo),
            docFile: new FormControl(''),
            DocumentFile: new FormControl(''),
            TclcDocId: new FormControl('')
          }));
        });
        this.DocTable = true;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.isdisabled = false;
        this.spinner.hide();
      }
    });
  }

  Save() {
    // Mark all main fields as touched to show validation errors
    this.markFormTouched();
    
    // Check main form validity
    if (this.AttestationForm.invalid) {
      let errorMsg = 'Please fill all required fields:\n';
      const controls = this.AttestationForm.controls;
      if (controls['StuCourse'].invalid) errorMsg += '- Course is required\n';
      if (controls['StuClg'].invalid) errorMsg += '- College is required\n';
      if (controls['StuFromDate'].invalid) errorMsg += '- From Date is required\n';
      if (controls['StuToDate'].invalid) errorMsg += '- To Date is required\n';
      if (controls['CouncilRegNo'].invalid) errorMsg += '- Council Registration Number is required\n';
      if (controls['StuEmail'].invalid) errorMsg += '- Email is required\n';
      if (controls['StuCertCopies'].invalid) errorMsg += '- Number of Additional Sets is required\n';
      if (controls['DeliveryOpt'].invalid) errorMsg += '- Delivery Option is required\n';
      if (this.AttestationForm.value.DeliveryOpt === 'Soft' && !this.AttestationForm.value.EmailId) {
        errorMsg += '- Email Id is required for Soft Copy delivery\n';
      }
      if (this.AttestationForm.value.DeliveryOpt === 'Hard' && !this.AttestationForm.value.PostalAdd) {
        errorMsg += '- Postal Address is required for Hard Copy delivery\n';
      }
      this.showError(errorMsg);
      return;
    }

    const creds = this.AttestationForm.get('arrData') as FormArray;
    let missingDocs = [];
    let oversizeDocs = [];
    creds.controls.forEach((ctrl, idx) => {
      const docName = ctrl.get('DocumentName')?.value || `Document ${idx+1}`;
      const fileControl = ctrl.get('DocumentFile');
      if (!fileControl?.value) {
        missingDocs.push(docName);
        fileControl?.setErrors({ required: true });
        fileControl?.markAsTouched();
      } else if (fileControl?.hasError('maxSize')) {
        oversizeDocs.push(docName);
        fileControl.markAsTouched();
      }
    });

    if (missingDocs.length > 0) {
      this.showError(`Please upload the following documents:\n${missingDocs.join('\n')}`);
      return;
    }

    if (oversizeDocs.length > 0) {
      this.showError(`File size must not exceed 50KB for:\n${oversizeDocs.join('\n')}`);
      return;
    }
    this.Submit();
  }

  markFormTouched() {
    ['StuCourse', 'StuClg', 'StuFromDate', 'StuToDate', 'CouncilRegNo', 'StuCertCopies', 'DeliveryOpt', 'StuEmail'].forEach(field => {
      this.AttestationForm.get(field)?.markAsTouched();
    });
    if (this.AttestationForm.value.DeliveryOpt === 'Soft') {
      this.AttestationForm.get('EmailId')?.markAsTouched();
    }
    if (this.AttestationForm.value.DeliveryOpt === 'Hard') {
      this.AttestationForm.get('PostalAdd')?.markAsTouched();
    }
  }

  Submit() {
    this.spinner.show();
    const form = this.AttestationForm.value;
    const payload: any = {
      StuId: this.StuId,
      StuFromDate: this.datePipe.transform(form.StuFromDate, 'yyyy-MM-dd'),
      StuToDate: this.datePipe.transform(form.StuToDate, 'yyyy-MM-dd'),
      CouncilRegNo: form.CouncilRegNo,
      StuCertCopies: form.StuCertCopies,
      FeeStatus: '',
      CertType: 'ATTFE',
      CertStatus: 'Submitted',
      StatusBy: sessionStorage.getItem('loginId'),
      DocStatus: 'Y',
      Comment: '',
      SnNo: parseInt(sessionStorage.getItem('session')),
      StuName: form.StuName,
      PostalAdd: form.PostalAdd,
      DeliverAt: form.DeliverAt,
      EmailId: form.EmailId,
      DeliveryOpt: form.DeliveryOpt,
      StuCourse: form.StuCourse,
      StuCollege: form.StuClg,
      StuAdd: form.StuAdd,
      StuEmail: form.StuEmail,
      StuPin: form.StuPin,
      StuPhone: form.StuPhone,
      StuPRN: this.RegnNo
    };
    this.umsService.AddTranscript(payload).subscribe({
      next: (res) => {
        if (res.status) this.SubmitTclc();
        else this.showError(res.message);
      },
      error: (err) => this.showError(err.error?.message)
    });
  }

  SubmitTclc() {
    const payload = {
      StuFaculty: '', StuCourse: this.AttestationForm.value.StuCourse,
      StuCollege: this.AttestationForm.value.StuClg, StuExam: '', StuBranch: '',
      SnNo: parseInt(sessionStorage.getItem('session')), CertType: 'ATTFE',
      DestClg: '', Reason: '', Other: '', FeeStatus: '', CertStatus: 'Submitted',
      StuId: this.StuId,     StuName: this.AttestationForm.value.StuName,
      Comment: '', CertScr: '', StatusBy: sessionStorage.getItem('loginId'),
      DocStatus: 'Y'
    };
    this.umsService.AddTclc(payload).subscribe({
      next: (res) => { if (res.status) this.AddTclcDoc(); else this.showError(res.message); },
      error: (err) => this.showError(err.error?.message)
    });
  }

  AddTclcDoc() {
    let isError = false;
    const creds = this.AttestationForm.get('arrData') as FormArray;
    const promises = creds.value.map((element, idx) => {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          const payload = {
            StuId: this.StuId, CertType: 'ATTFE', DocName: element.DocumentName,
            FileUpload: this.fileUploads[idx], SrNo: element.SrNo
          };
          this.umsService.AddTclcDoc(payload).subscribe({
            next: (res) => { if (!res.status) isError = true; resolve(); },
            error: () => { isError = true; resolve(); }
          });
        }, idx * 2000);
      });
    });
    Promise.all(promises).then(() => {
      this.spinner.hide();
      if (!isError) {
        this.showSuccess('Submitted Successfully');
        this.GetAttestation(this.StuId);
        this.saveApplicationDetails();
      } else {
        this.showError(this.errMsg || 'Upload failed');
      }
    });
  }

  Update() {
    if (this.AttestationForm.invalid) {
      this.markFormTouched();
      return;
    }
    this.spinner.show();
    const form = this.AttestationForm.value;
    const payload: any = {
      StuId: this.StuId,
      StuFromDate: this.datePipe.transform(form.StuFromDate, 'yyyy-MM-dd'),
      StuToDate: this.datePipe.transform(form.StuToDate, 'yyyy-MM-dd'),
      CouncilRegNo: form.CouncilRegNo,
      StuCertCopies: form.StuCertCopies,
      FeeStatus: 'Y',
      CertType: 'ATTFE',
      CertStatus: 'ReSubmitted',
      StatusBy: sessionStorage.getItem('loginId'),
      DocStatus: 'Y',
      Comment: '',
      SnNo: parseInt(sessionStorage.getItem('session')),
      StuName: form.StuName,
      TranscriptId: form.AttestationId,
      PostalAdd: form.PostalAdd,
      EmailId: form.EmailId,
      DeliveryOpt: form.DeliveryOpt,
      StuCourse: form.StuCourse,
      StuCollege: form.StuClg,
      StuAdd: form.StuAdd,
      StuEmail: form.StuEmail,
      StuPin: form.StuPin,
      StuPhone: form.StuPhone,
      StuPRN: this.RegnNo,
      DeliverAt: form.DeliverAt
    };
    this.umsService.UpdateTranscript(payload).subscribe({
      next: (res) => { if (res.status) this.UpdateTclc(); else this.showError(res.message); },
      error: (err) => this.showError(err.error?.message)
    });
  }

  UpdateTclc() {
    const payload = {
      StuFaculty: '', StuCourse: this.AttestationForm.value.StuCourse,
      StuCollege: this.AttestationForm.value.StuClg, StuExam: '', StuBranch: '',
      SnNo: parseInt(sessionStorage.getItem('session')), CertType: 'ATTFE',
      DestClg: '', Reason: '', Other: '', FeeStatus: this.FeeStatus,
      CertStatus: 'ReSubmitted', StuId: this.StuId, Comment: '', CertScr: '',
      StatusBy: sessionStorage.getItem('loginId'), DocStatus: 'Y', TclcId: this.TclcId
    };
    this.umsService.UpdateTclc(payload).subscribe({
      next: (res) => { if (res.status) this.UpdateTclcDoc(); else this.showError(res.message); },
      error: (err) => this.showError(err.error?.message)
    });
  }

  UpdateTclcDoc() {
    let isError = false;
    const creds = this.AttestationForm.get('arrData') as FormArray;
    const promises = creds.value.map((element, idx) => {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          const payload = {
            StuId: this.StuId, CertType: 'ATTFE', DocName: element.DocumentName,
            FileUpload: this.fileUploads[idx] || element.DocumentFile,
            TclcDocId: element.TclcDocId, SrNo: idx + 1
          };
          this.umsService.UpdateTclcDoc(payload).subscribe({
            next: (res) => { if (!res.status) isError = true; resolve(); },
            error: () => { isError = true; resolve(); }
          });
        }, idx * 2000);
      });
    });
    Promise.all(promises).then(() => {
      this.spinner.hide();
      if (!isError) {
        this.showSuccess('Updated Successfully');
        this.GetAttestation(this.StuId);
      } else {
        this.showError(this.errMsg || 'Update failed');
      }
    });
  }
  PayFees() {
    const data = this.AttestationForm.value;
    this.umsService.setTclcData([{
      StuCourse: data.StuCourse, StuClg: data.StuClg,
      SnNo: parseInt(sessionStorage.getItem('session')), CertType: 'ATTFE',
      StudentName: data.StuName
    }]);
    this.router.navigate(['TCLCFees']);
  }

  getFeeTempData() {
    this.spinner.show();
    this.umsService.fetchFeeTempTclc({ FeeType: 'ATTFE' }).subscribe({
      next: (res) => {
        if (res.status) this.openPaymentReceipt(res.data[0]['TemplateCode']);
        else this.spinner.hide();
      },
      error: () => this.spinner.hide()
    });
  }

  openPaymentReceipt(tempCode: string) {
    this.dialog.open(PaymentReceiptComponent, {
      width: '90vh', height: '80vh',
      data: {
        SnNo: parseInt(sessionStorage.getItem('session')),
        TemplateCode: tempCode, FeeType: 'ATTFE',
        studentname: this.StuFullName,
        college: this.AttestationForm.value.StuClg,
        course: this.AttestationForm.value.StuCourse
      },
      disableClose: true
    });
  }

  ValidateFee(StuId: number, FeeType: string, data: any) {
    this.umsService.ValidateFees({ StuId, FeeType, SnNo: sessionStorage.getItem('session') }).subscribe({
      next: () => this.getFeeTempData2(StuId, FeeType, data)
    });
  }

  getFeeTempData2(StuId: number, FeeType: string, data: any) {
    this.umsService.fetchFeeTempTclc({ FeeType }).subscribe({
      next: (res) => {
        if (res.status) this.SearchFeeDetails(res.data[0]['TemplateCode'], StuId, data);
        else this.spinner.hide();
      }
    });
  }

  SearchFeeDetails(tempCode: string, StuId: number, data: any) {
    this.umsService.getSearchTranscriptFeeDetails({
      FeeTemplateCode: tempCode, StuId, FeeHistory: 0, SnNo: sessionStorage.getItem('session')
    }).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) this.updateTC(StuId, data);
        else { this.PayDisabled = false; this.PayRecpt = false; this.PayFee = true; }
      }
    });
  }

  updateTC(StuId: number, data: any) {
    const payload = {
      StuFaculty: data.StuFaculty, StuCourse: data.StuCourse, StuCollege: data.StuCollege,
      StuExam: data.StuExam, StuBranch: data.StuBranch, SnNo: parseInt(sessionStorage.getItem('session')),
      CertType: data.CertType, DestClg: data.DestClg, Reason: data.Reason, FeeStatus: 'Y',
      CertStatus: 'Fees Paid', StuId: data.StuId, TclcId: data.TclcId, Comment: '', CertScr: '',
      StatusBy: sessionStorage.getItem('loginId')
    };
    this.umsService.UpdateTclc(payload).subscribe(() => this.getTclcData(StuId));
  }

  UploadedDocs() {
    this.spinner.show()
    let payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
    payload['StuId'] = this.StuId
    payload['CertType'] = 'ATTFE'
    this.umsService.GetTcLcDocUploadDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.AdminUpload = res.data

      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }


  saveApplicationDetails() {
    this.umsService.saveApplicationDetails({
      StuId: this.StuId, SessionId: parseInt(sessionStorage.getItem('session')),
      CgCode: this.AttestationForm.value.StuClg, CoCode: this.AttestationForm.value.StuCourse,
      ApplicationName: 'ATTFE', ApplicationSubDate: new Date().toISOString().slice(0, 10)
    }).subscribe();
  }

  onFileSelected(event: Event, rowIndex: number) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    const formArray = this.AttestationForm.get('arrData') as FormArray;
    const fileControl = formArray.at(rowIndex).get('DocumentFile');

    // Restrict document upload size to 50KB per document
    if (file.size > this.MAX_FILE_SIZE) {
      fileControl?.setErrors({ maxSize: true });
      fileControl?.markAsTouched();
      this.showError('File size must not exceed 50KB');
      input.value = '';
      return;
    }

    // Clear any previous maxSize error before continuing
    if (fileControl?.hasError('maxSize')) {
      const existingErrors = fileControl.errors;
      if (existingErrors) {
        delete existingErrors['maxSize'];
        fileControl.setErrors(Object.keys(existingErrors).length ? existingErrors : null);
      }
    }

    const ext = file.name.split('.').pop()?.toLowerCase();
    const docName = formArray.at(rowIndex).get('DocumentName')?.value;
    const isPhoto = docName === 'Photo of student';
    if ((isPhoto && !['png', 'jpeg', 'jpg'].includes(ext)) || (!isPhoto && ext !== 'pdf')) {
      this.showError(isPhoto ? 'Only PNG, JPEG, JPG allowed' : 'Only PDF allowed');
      input.value = '';
      return;
    }
    this.convertToBase64(file, rowIndex);
    formArray.at(rowIndex).get('DocumentFile')?.setValue(file.name);
  }

  convertToBase64(file: File, rowIndex: number) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (!this.fileUploads) this.fileUploads = [];
      this.fileUploads[rowIndex] = reader.result;
      const fa = (this.AttestationForm.get('arrData') as FormArray).at(rowIndex);
      fa.get('docFile')?.setValue(reader.result?.toString().split(',')[1]);
    };
  }

  showbase64(fileBase64: string) {
    this.dialog.open(PdfviewerComponent, { width: '400px', height: '500px', data: fileBase64 });
  }

  downloadCertificate() {
    if (this.AdminUpload.length) {
      this.dialog.open(PdfviewerComponent, { width: '400px', height: '500px', data: this.AdminUpload[0].FileUpload });
    }
  }


  Back() { this.location.back(); }

  showSuccess(msg: string) {
    this.dialogRef = this.modalPopupService.openPopup(AlertboxComponent, {
      message: msg, title: 'Information', icon: 'fas fa-check'
    });
  }

  showError(msg: string) {
    this.dialogRef = this.modalPopupService.openPopup(AlertboxComponent, {
      message: msg, title: 'Alert', icon: 'fas fa-close'
    });
  }
}